import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "decrement", "increment"];

  connect() {
    this.refresh();
  }

  increment() {
    this.applyStep(1);
  }

  decrement() {
    this.applyStep(-1);
  }

  applyStep(direction) {
    const current = this.currentValue();
    const next = this.clamp(current + direction * this.step());

    if (next === current) {
      return;
    }

    this.inputTarget.value = next;
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }));
    this.refresh();
  }

  refresh() {
    const value = this.currentValue();

    if (this.hasDecrementTarget) {
      this.decrementTarget.disabled = value <= this.min();
    }

    if (this.hasIncrementTarget) {
      this.incrementTarget.disabled = value >= this.max();
    }
  }

  currentValue() {
    return this.clamp(this.toNumber(this.inputTarget.value, this.min()));
  }

  clamp(value) {
    return Math.min(Math.max(value, this.min()), this.max());
  }

  step() {
    return this.toNumber(this.inputTarget.step, 1) || 1;
  }

  min() {
    return this.toNumber(this.inputTarget.min, 1);
  }

  max() {
    return this.toNumber(this.inputTarget.max, Infinity);
  }

  toNumber(value, fallback) {
    const parsed = parseInt(value, 10);

    return isNaN(parsed) ? fallback : parsed;
  }
}
